
const width = window.innerWidth;

export const mapMaxWidth = () => {

    if (width<=2560 && width > 1920){
        return 280
    }
    if (width<=1920 && width > 1792){
        return 170
    }
    if (width<=1792 && width > 1680){
        return 145
    }
    if (width<=1680 && width > 1600){
        return 125
    }
    if (width<=1600 && width > 1536){
        return 120
    }
    if (width<=1536 && width > 1440){
        return 110
    }

    return 100
}
